import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '.back-btn',
  standalone: false
})
export class BackBtnDirective {

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  @HostListener('click')
  onClick() {
    const self = this.el.nativeElement;

    const parent = self.parentElement;
    const siblingParent = self.parentElement?.parentElement?.previousElementSibling?.parentElement;
    const menu = this.closest(self, '.menu') as HTMLElement;

    if (parent) {
      this.renderer.removeClass(parent, 'in-view');
    }

    if (siblingParent) {
      this.renderer.removeClass(siblingParent, 'off-view');

      if (siblingParent.classList.contains('menu')) {
        const offcanvasMenu = document.querySelector('.offcanvas-menu .menu') as HTMLElement;
        if (offcanvasMenu) {
          menu.style.height = `${offcanvasMenu.offsetHeight}px`;
        }
      } else {
        menu.style.height = `${siblingParent.clientHeight}px`;
      }
    }
  }

  private closest(el: HTMLElement, selector: string): HTMLElement | null {
    let currentEl: HTMLElement | null = el;
    while (currentEl && !currentEl.matches(selector)) {
      currentEl = currentEl.parentElement;
    }
    return currentEl;
  }
}
